import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useQueryParams, NoSidebarPageLayout } from '@insurancemenu/imenu-components-lib';
import { SUBSCRIBER_CARD_DATA } from 'global/checklists-helpers/SubscriberChecklistHelper';
import ReviewSubscriberContent from 'components/subscriber/review-subscriber';
import ReviewNote from 'components/subscriber/review-subscriber/ReviewNote';
import { observer } from 'mobx-react-lite';
import { useRootStore } from 'store/rootStore';
import { buildGroupContextMoreInfoBlobProps } from 'components/common/group/GroupContextMoreInfoBlob';
import { buildGroupContactInfoMap } from 'global/services-helpers/groupService';

// TESTING_POLICY: CYPRESS_ONLY

const ReviewSubscriberPage: React.FC = observer(() => {
  const { periodId } = useParams<{ periodId: string }>();
  const query = useQueryParams();
  const subscriberId = query.get('subId') || '';
  const groupId = query.get('groupId') || '';

  const {
    reviewSubscriberStore: { group, loading, getInitialData, onBackRedirect },
  } = useRootStore();

  if (!subscriberId) return null;

  useEffect(() => {
    void getInitialData(subscriberId, periodId, groupId);
  }, []);

  return (
    <NoSidebarPageLayout
      contentWidth="standard"
      isInitialLoading={loading}
      isInfoSectionLoading={loading}
      moreInfoBlob={buildGroupContextMoreInfoBlobProps({
        blobTitle: group?.name || '',
        generalInfoMap: { group: group?.name || '' },
        contactInfoMap: buildGroupContactInfoMap(group?.contactInfo ?? null),
      })}
      pageHeader={{
        title: SUBSCRIBER_CARD_DATA.REVIEW_AND_CONFIRM.title,
        onBackButtonClick: onBackRedirect,
        spacing: { top: 'm', bottom: 'm' },
      }}
    >
      <ReviewNote />
      <ReviewSubscriberContent />
    </NoSidebarPageLayout>
  );
});

export default ReviewSubscriberPage;
